/* ----------------------------------------------------------------------------
wraps a form, submits it to Loops via fetch, and reflects state on the button
---------------------------------------------------------------------------- */

const STRINGS = {
  default: 'Subscribe',
  submitting: 'Submitting…',
  success: 'Thanks for subscribing',
  error: 'Try again',
};

export default class LoopsForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.button = this.querySelector('button[type="submit"]');
    if (!this.form || !this.button) return;

    this.defaultLabel = this.button.textContent.trim() || STRINGS.default;
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
  }

  async handleSubmit(event) {
    event.preventDefault();
    if (this.submitting) return;

    this.setState('submitting');

    try {
      const body = new URLSearchParams(new FormData(this.form));
      const response = await fetch(this.form.action, {
        method: 'POST',
        body,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });

      if (response.status === 429) {
        this.setState('error');
        return;
      }

      const data = await response.json();
      if (data?.success) {
        this.clearFields();
        this.setState('success');
      } else {
        this.setState('error');
      }
    } catch (error) {
      this.setState('error');
    }
  }

  clearFields() {
    for (const field of this.form.querySelectorAll(
      'input:not([type="hidden"]), textarea',
    )) {
      field.value = '';
    }
  }

  setState(state) {
    this.submitting = state === 'submitting';
    this.button.disabled = state === 'submitting' || state === 'success';
    this.button.textContent =
      state === 'default' ? this.defaultLabel : STRINGS[state];

    // let the user try again after an error
    if (state === 'error') {
      setTimeout(() => this.setState('default'), 4000);
    }
  }
}

window.customElements.define('loops-form', LoopsForm);
